import { Theme } from '@mui/material/styles';

export const checkIsDarkTheme = (theme: Theme) => theme.palette.mode === 'dark';
